import React, { useState, useEffect } from "react";
import RayalchatDeviceService from "../../Service/RayalchatDeviceService";
import MasterCommonTable from "../../UiComponents/CommonTable/MasterCommonTable";
import { Grid } from "@mui/material";
import Loader from "../../UiComponents/Loader/Loader";

const RayalchatUsersInfo = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorText, setErrorText] = useState("");

    const fetchUsers = async () => {
        if (!RayalchatDeviceService.isConfigured()) {
            setErrorText("The Rayalchat server is not configured. Set React_App_RAYALCHAT_BACKEND_URL in the frontend .env and rebuild.");
            return;
        }
        setLoading(true);
        setErrorText("");
        try {
            const response = await RayalchatDeviceService.getAllDeviceInfos();
            const list = response?.data?.data || response?.data || [];
            const ModifiedData = (Array.isArray(list) ? list : []).map((item) => ({
                ...item,
                appVersion: item?.deviceInfo?.appVersion,
                osName: item?.deviceInfo?.platform,
                osVersion: item?.deviceInfo?.osVersion,
                brand: item?.deviceInfo?.brand,
                model: item?.deviceInfo?.model,
            }));
            setUsers(ModifiedData);
        } catch (error) {
            console.error("Failed to fetch rayalchat users", error);
            setErrorText("The Rayalchat server could not be reached.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);
    const columns = [
        {
            id: "name",
            label: "Name",
            align: "left",
            minWidth: 150,
            render: (row) => row.name || "-",
        },
        {
            id: "mobile",
            label: "Mobile",
            align: "left",
            minWidth: 120,
        },
        {
            id: "appVersion",
            label: "App Version",
            align: "left",
            minWidth: 100,
        },
        {
            id: "osName",
            label: "OS",
            align: "left",
            minWidth: 100,
        },
        {
            id: "osVersion",
            label: "OS Version",
            align: "left",
            minWidth: 100,
        },
        {
            id: "brand",
            label: "Brand",
            align: "left",
            minWidth: 100,
        },
        {
            id: "model",
            label: "Model",
            align: "left",
            minWidth: 100,
        },
    ];

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <Grid container gap={2}>
                    {errorText && (
                        <Grid item xs={12}>
                            <div role="alert" style={{ padding: "12px 16px", color: "#b42318", background: "#fef3f2", border: "1px solid #fecdca", borderRadius: 8, fontFamily: "Inter", fontSize: 14 }}>
                                {errorText}
                            </div>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <MasterCommonTable
                            columns={columns}
                            data={users}
                            headerTitle="Rayalchat Users Device Info"
                            tableConfig={{}}
                        />
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default RayalchatUsersInfo;
